// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
/**
 * The following are shared across all platforms and apps
 */
.captcha-container {
  width: 315px;
  padding-bottom: 10px;
  box-shadow: 0px 0px 8px 0px #ccc;
}
.captcha-container .powered-by {
  font-size: 11px;
  font-family: Arial;
  color: #ccc;
  padding: 5px;
  display: block !important;
}

.captcha-actions {
  padding-left: 5px;
  padding-top: 5px;
}
.captcha-actions input[type=text] {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 10px 0 0 10px;
  outline: none;
}
.captcha-actions input[type=button] {
  outline: none;
  padding: 6px;
  border: none;
  background: #ccc;
  border-radius: 0 10px 10px 0;
}
.captcha-actions a {
  padding: 10px;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  text-decoration: none;
  color: #222;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/captcha/components/captcha.component.scss"],"names":[],"mappings":"AAAA;;EAAA;AAAA;;EAAA;ACMA;EACE,YAAA;EACA,oBAAA;EACA,gCAAA;AACF;AAAE;EACE,eAAA;EACA,kBARY;EASZ,WAVM;EAWN,YAAA;EACA,yBAAA;AAEJ;;AACA;EACE,iBAAA;EACA,gBAAA;AAEF;AADE;EACE,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;AAGJ;AADE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;AAGJ;AADE;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAtCM;AAyCV","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '@eview/scss/index';\n@import '../../../../scss/variables';\n$color_1: #222;\n$color_2: #ccc;\n$font-family_1: Arial;\n\n.captcha-container {\n  width: 315px;\n  padding-bottom: 10px;\n  box-shadow: 0px 0px 8px 0px #ccc;\n  .powered-by {\n    font-size: 11px;\n    font-family: $font-family_1;\n    color: $color_2;\n    padding: 5px;\n    display: block !important;\n  }\n}\n.captcha-actions {\n  padding-left: 5px;\n  padding-top: 5px;\n  input[type='text'] {\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 10px 0 0 10px;\n    outline: none;\n  }\n  input[type='button'] {\n    outline: none;\n    padding: 6px;\n    border: none;\n    background: #ccc;\n    border-radius: 0 10px 10px 0;\n  }\n  a {\n    padding: 10px;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: bold;\n    text-decoration: none;\n    color: $color_1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
